<script setup lang="ts">
import { computed } from 'vue';

import { AppButton, AppTooltip } from '@libs/ui';

import { useRecipeStore, useRouterStore } from '../../core/stores';

const recipeStore = useRecipeStore();
const routerStore = useRouterStore();
const isCarTripPlannerButtonDisabled = computed<boolean>(
  () => recipeStore.bookableTransportOnlyRecipe.length === 0
);
</script>

<template>
  <div class="car-trip-planner-button">
    <AppTooltip
      v-if="!isCarTripPlannerButtonDisabled"
      position="bottom-right"
      :ariaLabel="$t('planner.car_trip.disabled_button')"
    >
      <template #trigger>
        <AppButton
          class="car-trip-button"
          type="primary"
          state="disabled"
          size="small"
          :left-icon="{
            size: '18',
            name: 'route',
          }"
          @click="routerStore.navigateToCarTrip()"
        >
          <div class="button-content">
            <span>
              {{ $t('open_route_planner') }}
            </span>
          </div>
        </AppButton>
      </template>
      <template #default>
        {{ $t('planner.car_trip.disabled_button') }}
      </template>
    </AppTooltip>
    <AppButton
      v-else
      class="car-trip-button"
      type="primary"
      state="enabled"
      size="small"
      :left-icon="{
        size: '18',
        name: 'route',
      }"
      @click="routerStore.navigateToCarTrip()"
    >
      <div class="button-content">
        <span>
          {{ $t('open_route_planner') }}
        </span>
      </div>
    </AppButton>
  </div>
</template>

<style scoped lang="scss"></style>
